<template>
  <div class="trade_container">
    <div class="tabs">
      <el-tabs v-model="activeName"
               @tab-click="handleClick"
               class="tabsComtainer">
        <el-tab-pane label="全部"
                     name="3"></el-tab-pane>
        <el-tab-pane label="待支付"
                     name="0"></el-tab-pane>
        <el-tab-pane label="交易成功"
                     name="1"></el-tab-pane>
        <el-tab-pane label="交易失败"
                     name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="trade_search">
      <el-form class="search-form-inline">
        <el-form-item label="物流公司">
          <el-input v-model="companyName"
                    placeholder="请输入物流公司名称"
                    size="small"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="getTimes"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          size="small">
          </el-date-picker>
        </el-form-item>
        <el-button size="small"
                   @click='handleExportClick'
                   v-bind:class="multipleSelection.length!==0?'export':''"
                   class="exportBtn">
          导出
        </el-button>
        <el-button size="small"
                   class="search_btn"
                   @click="handleSeniorSearchClick">查询</el-button>

      </el-form>
    </div>
    <div class="special-container">
      <el-table :data="data.result"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                height="100%">
        <el-table-column class-name="number"
                         label=""
                         fixed
                         align="center"
                         type="index"
                         width="1">
        </el-table-column>
        <el-table-column type="selection"
                         width="56">
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="time"
                         label="时间"
                         width="88"
                         header-align="center"
                         align="left">
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="付款方角色">
          <template slot-scope="scope">
            <div v-if="scope.row.payType==='0'">物流公司</div>
            <div v-else-if="scope.row.payType==='1'">司机</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="付款方"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.payer}}</div>
          </template>
        </el-table-column>
        <el-table-column label="所属公司"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.fromCompany}}</div>
          </template>
        </el-table-column>
        <el-table-column label="收入(元)"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div class="income">{{scope.row.totalFee}}</div>
          </template>
        </el-table-column>
        <el-table-column label="收支类型"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.billType==='0'">收入</div>
          </template>
        </el-table-column>
        <el-table-column label="平台流水号"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.billNum}}</div>
          </template>
        </el-table-column>
        <el-table-column label="交易类型"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.transactionType==='0'">服务费</div>
          </template>
        </el-table-column>
        <el-table-column label="交易状态"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.payState==='0'"
                 class="wating">待支付</div>
            <div v-else-if="scope.row.payState==='1'"
                 class="complated">交易成功</div>
            <div v-else-if="scope.row.payState==='2'"
                 class="failure">交以失败</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         align="center">
          <template slot-scope="scope">
            <el-button type="primary"
                       plain
                       @click="handleWaybillClick(scope.row.billId)">查询详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pages">
        <span class="demonstartion"> 共{{data.total}}条记录</span>
        <el-pagination @current-change="handleCurrentChange"
                       :page-size="data.pageSize"
                       layout="prev, pager, next"
                       :total="data.total"
                       background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getBillList,
  downloadBill
} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      tiems: '',
      data: {},
      activeName: '3',
      companyName: '',
      getTimes: [],
      multipleSelection: [],
      exportIds: '',
      pageNum: 1
    }
  },
  methods: {
    handleExportClick () { // 导出
      // this.exportIds = ''
      // this.multipleSelection.forEach(element => {
      //   this.exportIds += element.billId + ','
      // })
      // this.exportIds = this.exportIds.substring(0, this.exportIds.length - 1)
      // console.log(this.exportIds)
      if (this.multipleSelection.length) {
        this.exportIds = ''
        this.multipleSelection.forEach(element => {
          this.exportIds += element.billId + ','
        })
        this.exportIds = this.exportIds.substring(0, this.exportIds.length - 1)
        // window.location.href = 'https://xiaoyu.jsh178.com/paybill/dowland.do?ids=' + this.exportIds
        window.location.href = downloadBill + this.exportIds
        // console.log(downloadBill)
      }
    },
    handleClick () { // 运单状态切换
      this.companyName = ''
      this.getTimes = []
      this.getData()
    },

    getData () { // 初始化
      getBillList({
        payState: this.activeName,
        pageNum: this.pageNum,
        startTime: this.getTimes[0],
        endTime: this.getTimes[1],
        fromCompany: this.companyName
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },

    handleSeniorSearchClick () { // 高级搜索
      this.getData()
    },
    handleWaybillClick (id) { // 运单详情
      // console.log(id)
      this.$router.push({
        path: 'tradeBill/billingDetail',
        query: { item: id }
      })
      //   this.$router.push({path: 'privateWaybill/privateDetail', query: {item: id}})
    },
    handleCurrentChange (val) { // 切页切换
      this.pageNum = val
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.trade_container
  height 100%
  .tabs
    width 100%
    height 49px
    overflow hidden
    border-bottom 1px solid #ccc
    .el-tabs__header
      margin 0
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px solid transparent
    .el-tabs__item
      padding 0
      text-align center
      height 49px
      line-height 50px
      overflow hidden
      width 92px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
    .el-tabs
      float left
      overflow hidden
    .tabsSelect
      float right
      margin-right 20px
      margin-top 5px
      .el-select .el-input
        width 110px
      .input-with-select .el-input-group__prepend
        background #fff
  .trade_search
    overflow hidden
    .search-form-inline
      width 100%
      float left
      margin-top 5px
      .el-form-item
        display inline-block
        margin-bottom 0
        label
          width 97px
        .el-form-item__content
          width 146px
          float left
        .company-name
          width 146px
          padding 0
          margin 0
        // .search-submit
        // padding 5px 20px
        // background #fff
        // text-align right
        // color $bgColor
        // size12()
        // &:hover
        // background $bgColor
        // color #fff
        .addressStyle
          width 146px
          line-height 30px
      .el-button
        float right
        width 78px
        margin-top 5px
        padding 7px 15px
      .search_btn
        border 1px solid $bgColor
        searchBtn()
      .exportBtn
        margin 5px 20px 0
      .export
        background #1B88EE
        border 1px solid #1B88EE
        color #fff
  .special-container
    margin-left 20px
    margin-top 10px
    margin-right 20px
    height calc(100% - 170px)
    .el-table
      background #f7f9fb
      th
        background #e7f0f8
    .el-table td div
      size12()
    .el-table th>.cell
      size12()
    .income
      color #f88
    .wating
      color #1B88EE
    .progress
      color #1B88EE
    .complated
      color #00D5B9
    .failure
      color #5E656F
    .el-button
      size12()
      border 1px solid #1B89EF
      color #1B89EF
      background #fff
      padding 7px 14px
    .pages
      margin-top 15px
      margin-bottom 15px
      .demonstartion
        float right
        line-height 45px
        color #5e656f
      .number
        font-weight 400
    .el-table td, .el-table th
      vertical-align top
</style>
